import { Button, Form, Input, Modal, Select, Spin } from 'antd';
import { useEffect, useRef, useState } from 'react';
import MonixModal from '@/global/components/monix-modal';
import { addMonitorParameterFunc } from '@/api/lib/lib-monitor-parameter';
import MonacoEditor from '@monaco-editor/react';
import { ReactComponent as AddSvg } from '@/global/icons/side-tool/add.svg';
import TnMessage from '@/global/components/message';
import { updateMonixDeviceFunction } from '@/api/lib/lib-sensor';
import { GlobalSensor } from '@/global/interface/lib-device/global-sensor';

interface IProps {
    visible: boolean,
    setVisible: (value: boolean) => void,
    onSuccess: () => void,
    sensor: GlobalSensor
}

export default function EditDeviceFunctionModal(props: IProps) {

    const [loading, setLoading] = useState<boolean>(false); // loading
    const [func, setFunc] = useState<string>("# 编写计算函数 由python语言编写"); // 计算函数

    const addBtnRef = useRef(null); // 添加表单的ref
    const [addForm] = Form.useForm(); // 添加表单

    useEffect(() => {
        if (props.sensor) {
            addForm.setFieldValue("functionName", props.sensor.receiveFunc);
            setFunc(props.sensor.functionContent);
        }
    }, [props.sensor])

    const onSaveClick = () => {
        if (loading) return;
        if (addBtnRef.current) {
            addBtnRef.current.click();
        }
    }

    const onFinish = (values) => {
        if (!props?.sensor) return;
        if (loading) return;

        setLoading(true);
        values = {
            ...values,
            content: func
        }
        updateMonixDeviceFunction(props.sensor.id, values).then(res => {
            if (res.status === 200) {
                if (res.data) {
                    TnMessage.success("添加成功");
                    props.onSuccess();
                } else {
                    TnMessage.info("该函数名已存在");
                }
            }
        }).catch(err => {
            TnMessage.error(err.data || "添加失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <MonixModal
            title={"编辑计算方法"}
            visible={props?.visible}
            setVisible={() => props.setVisible(false)}
            onSaveClick={onSaveClick}
            wrapClassName="calc-func-modal"
            saveDisable={loading}
        >
            <Spin wrapperClassName="calc-func-body" spinning={loading}>
                <Form
                    colon={false}
                    form={addForm}
                    autoComplete="off"
                    labelCol={{ span: 6 }}
                    onFinish={onFinish}
                    initialValues={{

                    }}
                >
                    <Form.Item label="方法名称:" name="functionName" rules={[{ required: true, message: '方法名称不能为空' }]}>
                        <Input />
                    </Form.Item>
                    <Button ref={addBtnRef} htmlType="submit" style={{ display: 'none' }}></Button>
                </Form>
                <MonacoEditor
                    height="500px"
                    defaultLanguage="python"
                    value={func}
                    theme="vs-dark"
                    onChange={(value, event) => {
                        setFunc(value);
                    }}
                    options={{
                        selectOnLineNumbers: true,
                        minimap: { enabled: false },
                        lineNumbers: "on",
                        scrollBeyondLastLine: false,
                    }}
                />
            </Spin>
        </MonixModal>
    )
}